import { Flex, Form, Select } from "antd";
import { useEffect, useState } from "react";
import RESTConfiguration from "./rest-configuration";
import SFTPConfiguration from "./sftp-configuration";
import SOAPConfiguration from "./soap-configuration";
import NoChannelConfiguration from "./no-channel-configuration";
import { Client } from "../../model/client-model";

const channelTypes = [
    { label: 'No Channel', value: null },
    { label: 'REST', value: 'REST' },
    { label: 'Secure FTP', value: 'SFTP' },
    { label: 'SOAP', value: 'SOAP' },
]
  
const TargetConfiguration = ({show, client, channel, onBack, onSave, onClose}: any) => {

    const [destinationChannelType, setDestinationChannelType] = useState<string | null>(null);

    const [form] = Form.useForm();

    useEffect(() => {
        form.setFieldsValue(channel);
        setDestinationChannelType(client?.destinationChannelType);
    }, [client]);

    const onSubmit = (client: Client) => {
        onSave({...client, destinationChannelType});
    }

    return <div className="clients-page-form" style={{overflow: 'hidden', height: show ? 'auto' : '0rem'}}>

        <h2>Target Configuration</h2>

        <Flex vertical>
            <label>Channel Type</label>
            <Select value={destinationChannelType} options={channelTypes} onChange={setDestinationChannelType} />
        </Flex>
        
        <NoChannelConfiguration client={client} 
            show={destinationChannelType === null} 
            channelField={'destination'}
            onBack={onBack} 
            onNext={onSubmit} 
            onClose={onClose}
            proceedLabel={'Save'}
        />
        <RESTConfiguration client={client} 
            show={destinationChannelType === 'REST'} 
            channelField={'destination'}
            onBack={onBack} 
            onNext={onSubmit} 
            onClose={onClose}
            proceedLabel={'Save'}
        />
        <SFTPConfiguration client={client} 
            show={destinationChannelType === 'SFTP'} 
            channelField={'destination'}
            onBack={onBack} 
            onNext={onSubmit} 
            onClose={onClose}
            proceedLabel={'Save'}
        />
        <SOAPConfiguration client={client} 
            show={destinationChannelType === 'SOAP'} 
            channelField={'destination'}
            onBack={onBack} 
            onNext={onSubmit} 
            onClose={onClose}
            proceedLabel={'Save'}
        />
    </div>
}

export default TargetConfiguration;